/**
 * Utility functions for GTM tracking in refine search
 */
import Vue from 'vue';
import { GTM_EVENT_NAME_SME_LEASE_CALCULATOR_CAR, GTM_EVENT_VALUES_LEASE_CALCULATOR_CAR, GTM_EVENT_STAGE_UPDATE_SEARCH } from './constants';

/**
 * Track refine search update event
 * @param {Object} gtmInstance - GTM instance (e.g., this.$gtm)
 * @param {Object} filterData - Filter data object
 * @param {Array<string>} filterData.makes - Array of selected makes
 * @param {Array<string>} filterData.fuelTypes - Array of selected fuel types
 * @param {Array<string>} filterData.bodyTypes - Array of selected body types
 */
export function trackRefineSearchUpdate(gtmInstance, filterData) {
  const { makes = [], fuelTypes = [], bodyTypes = [] } = filterData;

  const eventPayload = {
    event: GTM_EVENT_NAME_SME_LEASE_CALCULATOR_CAR,
    stage: GTM_EVENT_STAGE_UPDATE_SEARCH,
    data: {
      ...GTM_EVENT_VALUES_LEASE_CALCULATOR_CAR,
      ...(makes.length > 0 && { make: makes.join('|') }),
      ...(fuelTypes.length > 0 && { fuel: fuelTypes.join(',') }),
      ...(bodyTypes.length > 0 && { type: bodyTypes })
    }
  };

  // Use setTimeout to ensure GTM is ready (similar to other components)
  setTimeout(() => {
    try {
      // Try instance GTM first (this.$gtm), fallback to Vue.gtm (static)
      let gtm = gtmInstance;

      if (!gtm || typeof gtm.trackEvent !== 'function') {
        // Fallback to Vue.gtm if instance GTM is not available
        gtm = Vue.gtm;
      }

      // Try vue-gtm trackEvent first
      if (gtm && typeof gtm.trackEvent === 'function') {
        gtm.trackEvent(eventPayload);
      } else {
        // Fallback: Push directly to dataLayer if vue-gtm isn't working
        if (typeof window !== 'undefined' && Array.isArray(window.dataLayer)) {
          window.dataLayer.push(eventPayload);
        }
      }
    } catch (error) {
      // Silently fail - GTM tracking errors should not break the application
    }
  }, 0);
}
